import { createI18n } from 'vue-i18n';
import ptBR from './messages/pt-BR';
import en from './messages/en';

const LOCALE_KEY = 'beaconly.locale';

function detectLocale(): 'pt-BR' | 'en' {
  const saved = localStorage.getItem(LOCALE_KEY);
  if (saved === 'pt-BR' || saved === 'en') return saved;
  return navigator.language.toLowerCase().startsWith('pt') ? 'pt-BR' : 'en';
}

export const i18n = createI18n({
  // Composition API mode (legacy is deprecated in v11) with global
  // injection — $t stays available in templates, including v-cipher
  // bindings. warnHtmlMessage: the step snippets intentionally contain
  // </body> and <script> tags, rendered as plain text (textContent).
  legacy: false,
  globalInjection: true,
  warnHtmlMessage: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { 'pt-BR': ptBR, en },
});

export function applyLocale(locale: 'pt-BR' | 'en'): void {
  document.documentElement.lang = locale;
  document.title = i18n.global.t('seo.title');
  const meta = document.querySelector('meta[name="description"]');
  if (meta) meta.setAttribute('content', i18n.global.t('seo.description'));
}

export function setLocale(locale: 'pt-BR' | 'en'): void {
  // Composition mode: global.locale is a computed ref — write via .value
  i18n.global.locale.value = locale;
  localStorage.setItem(LOCALE_KEY, locale);
  applyLocale(locale);
}

export function currentLocale(): 'pt-BR' | 'en' {
  return i18n.global.locale.value;
}

// Keep <html lang>, tab title and meta description in sync on first load
applyLocale(i18n.global.locale.value);